module.exports = __webpack_public_path__ + "img/river.97f090db.svg";